import { Box, Grid, Typography } from "@mui/material";
import { useMemo } from "react";

import BarChartCustom from "../../../../../components/shared/chart/BarChartCustom";
import { formatNumber } from "../../../../../../infrastructure/utils/formatters";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { pick } from "../managementDashboardUtils";

const topN = (contractors, n, sortFn) =>
  [...(contractors || [])].sort(sortFn).slice(0, n);

const ContractorPerformanceCharts = ({ loading, error, data, onRetry }) => {
  const contractors = data?.contractors || data?.Contractors || [];

  const capacityChart = useMemo(
    () =>
      topN(contractors, 8, (a, b) =>
        (pick(b, "totalCapacityKw", "TotalCapacityKw") ?? 0)
        - (pick(a, "totalCapacityKw", "TotalCapacityKw") ?? 0)
      ).map((c) => ({
        x: pick(c, "contractorTitle", "ContractorTitle"),
        ظرفیت: pick(c, "totalCapacityKw", "TotalCapacityKw") ?? 0,
      })),
    [contractors]
  );

  const conversionChart = useMemo(
    () =>
      topN(contractors, 8, (a, b) =>
        (pick(b, "conversionRate", "ConversionRate") ?? 0)
        - (pick(a, "conversionRate", "ConversionRate") ?? 0)
      ).map((c) => ({
        x: pick(c, "contractorTitle", "ContractorTitle"),
        "نرخ تبدیل": pick(c, "conversionRate", "ConversionRate") ?? 0,
      })),
    [contractors]
  );

  const delayChart = useMemo(
    () =>
      topN(contractors, 8, (a, b) =>
        (pick(b, "averageDelayDays", "AverageDelayDays") ?? 0)
        - (pick(a, "averageDelayDays", "AverageDelayDays") ?? 0)
      ).map((c) => ({
        x: pick(c, "contractorTitle", "ContractorTitle"),
        "تأخیر (روز)": pick(c, "averageDelayDays", "AverageDelayDays") ?? 0,
        درخواست: pick(c, "requestCount", "RequestCount") ?? 0,
      })),
    [contractors]
  );

  return (
    <ManagementWidgetShell
      title="نمودارهای عملکرد پیمانکار"
      subheader="برترین / پرتأخیرترین پیمانکاران"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      {!contractors.length && !loading && !error ? (
        <Typography color="text.secondary">داده پیمانکار برای نمودار موجود نیست.</Typography>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Typography fontWeight={600} fontSize={14} sx={{ mb: 1 }}>
              ظرفیت نصب‌شده
            </Typography>
            <Box sx={{ height: 280 }}>
              <BarChartCustom
                data={capacityChart}
                series={["ظرفیت"]}
                xAxis="x"
                yAxisTitle="kW"
                colors={["#1976d2"]}
                loading={loading}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography fontWeight={600} fontSize={14} sx={{ mb: 1 }}>
              نرخ تبدیل
            </Typography>
            <Box sx={{ height: 280 }}>
              <BarChartCustom
                data={conversionChart}
                series={["نرخ تبدیل"]}
                xAxis="x"
                yAxisTitle="٪"
                colors={["#2e7d32"]}
                loading={loading}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography fontWeight={600} fontSize={14} sx={{ mb: 1 }}>
              بیشترین تأخیر
            </Typography>
            <Box sx={{ height: 280 }}>
              <BarChartCustom
                data={delayChart}
                series={["تأخیر (روز)"]}
                xAxis="x"
                yAxisTitle="روز"
                colors={["#ed6c02"]}
                loading={loading}
              />
            </Box>
            {delayChart.length ? (
              <Typography variant="caption" color="text.secondary">
                پراکندگی: محور X=تأخیر، اندازه=تعداد درخواست (جدول بالا)
              </Typography>
            ) : null}
          </Grid>
        </Grid>
      )}
    </ManagementWidgetShell>
  );
};

export default ContractorPerformanceCharts;
